import React, { useState, useRef, useEffect } from "react";
import { Map, AdvancedMarker, APIProvider } from "@vis.gl/react-google-maps";
import useNotification from "../CustomHook/useNotification";

const DEFAULT_POSITION = { lat: 28.6139, lng: 77.209 }; // Fallback: New Delhi

const MapComponent = ({ setPosition, position }) => {
  const notify = useNotification();
  const [currentPosition, setCurrentPosition] = useState(position);
  const mapRef = useRef(null);

  useEffect(() => {
    if (!position || !position.lat || !position.lng) {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (pos) => {
            const coords = {
              lat: pos.coords.latitude,
              lng: pos.coords.longitude,
            };
            setCurrentPosition(coords);
            setPosition(coords);
          },
          (error) => {
            console.error("Geolocation error:", error.message);

            switch (error.code) {
              case error.PERMISSION_DENIED:
                notify(
                  "Permission denied. Please enable location access in your device.",
                  "danger"
                );
                break;
              case error.POSITION_UNAVAILABLE:
                notify(
                  "Location unavailable. Please check your device settings.",
                  "danger"
                );

                break;
              case error.TIMEOUT:
                notify(
                  "Location request timed out. Try refreshing the page.",
                  "danger"
                );

                break;
              default:
                notify(
                  "An unknown error occurred while fetching your location.",
                  "danger"
                );
              // alert("An unknown error occurred while fetching your location.");
            }
            setCurrentPosition(DEFAULT_POSITION);
            setPosition(DEFAULT_POSITION);
          },
          {
            enableHighAccuracy: true,
            timeout: 10000,
            maximumAge: 0,
          }
        );
      } else {
        notify("Geolocation is not supported.", "danger");
        setCurrentPosition(DEFAULT_POSITION);
        setPosition(DEFAULT_POSITION);
      }
    } else {
      // If valid position is provided as prop, use it
      setCurrentPosition(position);
    }
  }, []);

  useEffect(() => {
    if (window.google && mapRef.current) {
      const input = document.getElementById("search-box");
      if (input) {
        const autocomplete = new window.google.maps.places.Autocomplete(input);
        autocomplete.addListener("place_changed", () => {
          const place = autocomplete.getPlace();
          if (place.geometry) {
            const newPosition = {
              lat: place.geometry.location.lat(),
              lng: place.geometry.location.lng(),
            };
            setPosition(newPosition);
            setCurrentPosition(newPosition);
            mapRef.current.panTo(newPosition);
          }
        });
      }
    }
  }, []);

  useEffect(() => {
    if (
      position &&
      (position.lat !== currentPosition.lat ||
        position.lng !== currentPosition.lng)
    ) {
      setCurrentPosition(position);
    }
  }, [position]);

  const handleDragEnd = (marker) => {
    const newPosition = {
      lat: marker.latLng.lat(),
      lng: marker.latLng.lng(),
    };
    console.log("working : ", newPosition);
    setCurrentPosition(newPosition);
    setPosition(newPosition);
  };

  return (
    <APIProvider
      apiKey="AIzaSyBq6om-bXkgEZe4whabKUmbKcHTcN70Q4k"
      libraries={["places"]}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {/* <input id="search-box" placeholder="Search a location" /> */}
        <Map
          defaultCenter={currentPosition}
          defaultZoom={13}
          style={{ height: "500px", width: "100%" }}
          onLoad={(map) => (mapRef.current = map)}
          mapId="demo_id"
        >
          <AdvancedMarker
            position={currentPosition}
            draggable
            onDragEnd={handleDragEnd}
          />
        </Map>
      </div>
    </APIProvider>
  );
};

export default MapComponent;

// import React, { useState, useRef, useEffect } from "react";
// import { Map, AdvancedMarker, APIProvider } from "@vis.gl/react-google-maps";
// import { Modal, Button } from "react-bootstrap"; // React Bootstrap components
// import useNotification from "../CustomHook/useNotification";

// // Default location: New Delhi
// const DEFAULT_POSITION = { lat: 28.6139, lng: 77.209 };

// const MapComponent = ({ setPosition, position }) => {
//   const notify = useNotification();
//   const [currentPosition, setCurrentPosition] = useState(position);
//   const mapRef = useRef(null);

//   // Modal state
//   const [showPermissionModal, setShowPermissionModal] = useState(false);

//   useEffect(() => {
//     if (!position || !position.lat || !position.lng) {
//       if (navigator.geolocation) {
//         navigator.geolocation.getCurrentPosition(
//           (pos) => {
//             const coords = {
//               lat: pos.coords.latitude,
//               lng: pos.coords.longitude,
//             };
//             setCurrentPosition(coords);
//             setPosition(coords);
//           },
//           (error) => {
//             console.error("Geolocation error:", error.message);

//             switch (error.code) {
//               case error.PERMISSION_DENIED:
//                 notify(
//                   "Permission denied. Please enable location access in your device.",
//                   "danger"
//                 );
//                 setShowPermissionModal(true); // Show modal
//                 break;
//               case error.POSITION_UNAVAILABLE:
//                 notify(
//                   "Location unavailable. Please check your device settings.",
//                   "danger"
//                 );
//                 break;
//               case error.TIMEOUT:
//                 notify(
//                   "Location request timed out. Try refreshing the page.",
//                   "danger"
//                 );
//                 break;
//               default:
//                 notify(
//                   "An unknown error occurred while fetching your location.",
//                   "danger"
//                 );
//             }

//             setCurrentPosition(DEFAULT_POSITION);
//             setPosition(DEFAULT_POSITION);
//           },
//           {
//             enableHighAccuracy: true,
//             timeout: 10000,
//             maximumAge: 0,
//           }
//         );
//       } else {
//         notify("Geolocation is not supported.", "danger");
//         setCurrentPosition(DEFAULT_POSITION);
//         setPosition(DEFAULT_POSITION);
//       }
//     } else {
//       setCurrentPosition(position);
//     }
//   }, []);

//   useEffect(() => {
//     if (window.google && mapRef.current) {
//       const input = document.getElementById("search-box");
//       if (input) {
//         const autocomplete = new window.google.maps.places.Autocomplete(input);
//         autocomplete.addListener("place_changed", () => {
//           const place = autocomplete.getPlace();
//           if (place.geometry) {
//             const newPosition = {
//               lat: place.geometry.location.lat(),
//               lng: place.geometry.location.lng(),
//             };
//             setPosition(newPosition);
//             setCurrentPosition(newPosition);
//             mapRef.current.panTo(newPosition);
//           }
//         });
//       }
//     }
//   }, []);

//   useEffect(() => {
//     if (
//       position &&
//       (position.lat !== currentPosition.lat ||
//         position.lng !== currentPosition.lng)
//     ) {
//       setCurrentPosition(position);
//     }
//   }, [position]);

//   const handleDragEnd = (marker) => {
//     const newPosition = {
//       lat: marker.latLng.lat(),
//       lng: marker.latLng.lng(),
//     };
//     setCurrentPosition(newPosition);
//     setPosition(newPosition);
//   };

//   return (
//     <APIProvider
//       apiKey="AIzaSyBq6om-bXkgEZe4whabKUmbKcHTcN70Q4k"
//       libraries={["places"]}
//     >
//       <div
//         style={{
//           display: "flex",
//           flexDirection: "column",
//           alignItems: "center",
//         }}
//       >
//         {/* Uncomment to enable place search */}
//         {/* <input id="search-box" placeholder="Search a location" /> */}

//         <Map
//           defaultCenter={currentPosition}
//           defaultZoom={13}
//           style={{ height: "500px", width: "100%" }}
//           onLoad={(map) => (mapRef.current = map)}
//           mapId="demo_id"
//         >
//           <AdvancedMarker
//             position={currentPosition}
//             draggable
//             onDragEnd={handleDragEnd}
//           />
//         </Map>
//       </div>

//       {/* React Bootstrap Modal for Permission Denied */}
//       <Modal
//         show={showPermissionModal}
//         onHide={() => setShowPermissionModal(false)}
//         centered
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>Location Access Denied</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <p>
//             Location access is denied. Please enable it in your browser settings
//             to use this feature.
//           </p>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button
//             variant="secondary"
//             onClick={() => setShowPermissionModal(false)}
//           >
//             Close
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </APIProvider>
//   );
// };

// export default MapComponent;
